import * as React from 'react';
import styled from 'styled-components';
import {formatCurrency} from '../AccountCheckout.map';

const StickyContainer = styled.div<{visible: boolean}>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
  padding: 15px 20px;
  z-index: 1000;
  transform: translateY(${(props) => (props.visible ? '0' : '100%')});
  transition: transform 0.3s ease;

  @media (min-width: 769px) {
    display: none;
  }
`;

const StickyContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  max-width: 1200px;
  margin: 0 auto;
`;

const PlanInfo = styled.div`
  flex: 1;
`;

const PlanName = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: #333;
  margin-bottom: 2px;
`;

const PlanPrice = styled.div`
  font-size: 16px;
  color: #4caf50;
  font-weight: 600;
`;

const CTAButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(118, 75, 162, 0.4);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(118, 75, 162, 0.5);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

interface StickyCTAProps {
  planName: string;
  planValue: number | string;
  onCtaClick: () => void;
  isSubmitting?: boolean;
}

export const StickyCTA: React.FC<StickyCTAProps> = ({
  planName,
  planValue,
  onCtaClick,
  isSubmitting = false,
}) => {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;

      setVisible(scrollPosition > windowHeight * 0.5);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <StickyContainer visible={visible}>
      <StickyContent>
        <PlanInfo>
          <PlanName>{planName}</PlanName>
          <PlanPrice>{formatCurrency(planValue)}</PlanPrice>
        </PlanInfo>
        <CTAButton onClick={onCtaClick} disabled={isSubmitting}>
          {isSubmitting ? 'Processando...' : 'Assinar Agora'}
        </CTAButton>
      </StickyContent>
    </StickyContainer>
  );
};
